export default __webpack_public_path__ + "static/media/icon__18.a7b611ee.svg";